
import {
    GET_INVOICES,
    GET_INVOICES_SUCCESS,
    GET_INVOICES_FAIL,
    UPDATE_INVOICE_STATUS,
    UPDATE_INVOICE_STATUS_SUCCESS,
    UPDATE_INVOICE_STATUS_FAIL
} from "./actionTypes"

export const getInvoices = () => ({
    type: GET_INVOICES,
})

export const getInvoicesSuccess = invoices => ({
    type: GET_INVOICES_SUCCESS,
    payload: invoices,
})

export const getInvoicesFail = error => ({
    type: GET_INVOICES_FAIL,
    payload: error,
})

export const updateInvoiceStatus = (invoiceId, status) => ({
    type: UPDATE_INVOICE_STATUS,
    payload: { invoiceId, status },
})

export const updateInvoiceStatusSuccess = invoice => ({
    type: UPDATE_INVOICE_STATUS_SUCCESS,
    payload: invoice,
})

export const updateInvoiceStatusFail = error => ({
    type: UPDATE_INVOICE_STATUS_FAIL,
    payload: error,
})
